module.exports = __webpack_public_path__ + "static/media/logo.d55b04d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 193
// module chunks = 0